<script>
import Swal from 'sweetalert2'

import Layout from "../../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Helper from '@/helpers/helper';
import { ref } from "vue";


/**
 * Dashboard Component
 */
export default {
    setup() {
        const doesAddOpen = ref(false);
        const doesEditOpen = ref(false);
        const doesDeleteOpen = ref(false);
        const doesLoadingOpen = ref(false)

        return {
          doesAddOpen,
          doesEditOpen,
          doesDeleteOpen,
          doesLoadingOpen
        };
    },
    page: {
    title: "contacts",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "contacts",
      items: [
        {
          text: "Définition",
        },
        {
          text: "contacts",
          active: true,
        },
      ],
      errors: [],
      contact: {},
      contacts: [],
      users: [],
      number: "",
      type: "",
      status: "",
      visibility: "",
      user_id: "",
      loading: false,
      statusHttp: 201,
    };
  },
  methods: {
    loadList() {
      fetch(Helper.route('contacts'), Helper.requestOptionsJSON())
      .then(response => {
          Helper.tokenChecker(response.status)
          return response.json()
      })
      .then(data => {
        console.log(data);
        this.doesLoadingOpen = false
        this.contacts = data
      })
    },

    refresh(){
      this.loadList();
    },

    loadUsers() {
      fetch(Helper.route('users'), Helper.requestOptionsJSON())
      .then(response => {
          Helper.tokenChecker(response.status)
          console.log(response);
          return response.json()
      })
      .then(data => {
        
        this.users = data

        console.log("users :", this.users);
        
      })
    },
    addItem() {
      this.loading = true
      this.errors = []
      let body = {
        number: this.number,
        type: this.type,
        status: this.status,
        visibility: this.visibility,
        user: {
          id: this.user_id
        }
      }
      console.log(body);
      
      fetch(Helper.route('contacts'), Helper.requestOptionsJSON("POST", body))
      .then(response => {
          //Helper.tokenChecker(response.status)
          this.statusHttp = response.status
          console.log(this.status);
          
          return response.json()
      })
      .then(data => {
        console.log(data);
        
        this.loading = false
        if (this.statusHttp == 201) {
          this.doesAddOpen = false
          this.contacts.push(data) 
          Swal.fire("contact ajouter !", "La contact a été enregistrée avec succès.", "success");
        } else {
            this.errors.name = Helper.getError(data, "name")
        }
      })
      .catch(error => {
        console.log(error);
        this.loading = false
      })
    },
    editItem() {
      this.loading = true
      this.errors = []
      let body = {
        number: this.number,
        type: this.type,
        status: this.status,
        visibility: this.visibility,
        user: {
          id: this.user_id
        }
      }
      fetch(Helper.route('contacts/'+this.contact.id), Helper.requestOptionsJSON("PUT", body))
      .then(response => {
          Helper.tokenChecker(response.status)
          this.status = response.status
          return response.json()
      })
      .then(data => {
        console.log(this.status);
        this.loading = false
        if (this.status == 200) {
          this.doesEditOpen = false
          this.contacts = this.contacts.map(i => i.id !== this.contact.id ? i : data)
          Swal.fire("contact modifier !", "La contact a été modifiée avec succès.", "success");
        } else {
            this.errors.name = Helper.getError(data, "constante_name")
        }
      })
      .catch(error => {
        console.log(error);
        this.loading = false
      })
    },
    deleteIt() {
      this.loading = true
      fetch(Helper.route('contacts/'+this.contact.id), Helper.requestOptions("DELETE"))
      .then(response => {
          Helper.tokenChecker(response.status)
          this.status = response.status
          return response.text()
      })
      .then(data => {
        console.log(this.status);
        console.log(data);
        if (this.status == 200) {
          this.contacts = this.contacts.filter(i => i.id !== this.contact.id)
          this.loading = false
          this.contact = null
          this.doesDeleteOpen = false
          Swal.fire("contact supprimer !", "La contact a été supprimée avec succès.", "success");
        } else {
          Swal.fire("contact non supprimer ?", "La suppression n'a pas marché, veuillez réessayez plus tard.", "error");
        }
      })
    },
    initItem(contact, action="edit") {
      this.contact = contact
      this.initData(contact)
      if (action == "delete") {
        this.doesDeleteOpen = true
      } else {
        this.doesEditOpen = true
      }
    },
    initData(item = null) {
      this.name = item != null ? item.name : ""
      this.value = item != null ? item.value : ""
      this.description = item != null ? item.description : ""
    }
  },
  mounted() {
    this.loadList()
    this.loadUsers()
    this.doesLoadingOpen = false
  },
  watch: {
    doesAddOpen: function() {
      this.errors = []
      if (!this.doesAddOpen) {
        this.initData(null)
      }
    },
    doesEditOpen: function() {
      this.errors = []
      if (!this.doesEditOpen) {
        this.initData(null)
        this.contact = null
      }
    },
    doesDeleteOpen: function() {
      if (!this.doesDeleteOpen) {
        this.initData(null)
        this.contact = null
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="hstack mb-3">
       <b-button variant="primary" @click="refresh()" class="ms-auto">
        <i class=" bx bx-refresh font-size-16 align-middle me-2"></i>
        Refresh
      </b-button>
        <b-button variant="primary" @click="doesAddOpen = true" class="ms-1">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Ajouter un nouveau
        </b-button>
    </div>
    
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des contacts</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <value>contacts</value>.
            </p>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Utilisateur</th>
                    <th>Numéro</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Visibilité</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(contact, i) in contacts" :key="contact.id">
                    <th scope="row">{{ i + 1 }}</th>
                    <td>{{ contact?.user?.lastName+" "+contact?.user?.firstName }}</td>
                    <td>{{ contact.number }}</td>
                    <td>{{ contact.type }}</td>
                    <td>{{ contact.status }}</td>
                    <td>{{ contact.visibility }}</td>
                    <td class="hstack">
                        <b-button class="btn-sm ms-2" @click="initItem(contact, 'edit')" variant="success">
                            <i class="bx bx-edit font-size-16 align-middle mx-1"></i>
                        </b-button>
                        <b-button variant="danger" @click="initItem(contact, 'delete')" class="ms-2 btn-sm">
                          <i class="bx bx-trash font-size-16 align-middle mx-1"></i>
                        </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            
          </div>
        </div>
      </div>
    </div>

    <!-- LOADING MODAL -->
    <b-modal v-model="doesLoadingOpen" id="modal-center" centered size="md" title="Chargement..."
      title-class="font-18" hide-footer>
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>

    <!-- ADD MODAL -->
    <b-modal
        v-model="doesAddOpen"
        id="modal-center"
        centered
        size="md"
        title="Ajouter un contact"
        title-class="font-18"
        hide-footer
        >
        <form @submit.prevent="addItem()">
          <div class="row">
            <div class="col-md-12 mb-3">
                <label for="">Sélectionnez l'utilisateur</label>
                <select required v-model="user_id" class="form-control">
                    <option value=""></option>
                    <option v-for="user in users" :key="user.id" :value="user.id">{{ user?.lastName+" "+user?.firstName }}</option>
                </select>
            </div>
            <div class="col-md-12 mb-3">
              <input type="text" placeholder="Numéro du contact" required v-model="number" class="form-control">
              <span class="text-danger mt-2" v-if="errors.number">{{ errors.number }}</span>
            </div>
            <div class="col-md-12 mb-3">
              <input type="text" placeholder="type" required v-model="type" class="form-control">
              <span class="text-danger mt-2" v-if="errors.type">{{ errors.type }}</span>
            </div>
            <div class="col-md-12 mb-3">
              <input type="text" placeholder="status" required v-model="status" class="form-control">
              <span class="text-danger mt-2" v-if="errors.status">{{ errors.status }}</span>
            </div>
            <div class="col-md-12 mb-3">
              <input type="text" placeholder="visibility" required v-model="visibility" class="form-control">
              <span class="text-danger mt-2" v-if="errors.visibility">{{ errors.visibility }}</span>
            </div>
          </div>
          <div class="mt-3" v-if="!loading">
            <input type="submit" value="Enregistrer" class="btn btn-primary">
          </div>
          <div class="mt-3 text-center" v-else>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
    </b-modal>


    <!-- EDIT MODAL -->
    <b-modal
        v-model="doesEditOpen"
        id="modal-center"
        centered
        size="md"
        title="Modifier un contact"
        title-class="font-18"
        hide-footer
        >
        <form @submit.prevent="editItem()">
          <div class="row">
            <div class="col-md-12 mb-3">
                <label for="">Sélectionnez l'utilisateur</label>
                <select required v-model="user_id" class="form-control">
                    <option value=""></option>
                    <option v-for="user in users" :key="user.id" :value="user.id">{{ user?.lastName+" "+user?.firstName }}</option>
                </select>
            </div>
            <div class="col-md-12 mb-3">
              <input type="text" placeholder="Numéro du contact" required v-model="number" class="form-control">
              <span class="text-danger mt-2" v-if="errors.number">{{ errors.number }}</span>
            </div>
            <div class="col-md-12 mb-3">
              <input type="text" placeholder="type" required v-model="type" class="form-control">
              <span class="text-danger mt-2" v-if="errors.type">{{ errors.type }}</span>
            </div>
            <div class="col-md-12 mb-3">
              <input type="text" placeholder="status" required v-model="status" class="form-control">
              <span class="text-danger mt-2" v-if="errors.status">{{ errors.status }}</span>
            </div>
            <div class="col-md-12 mb-3">
              <input type="text" placeholder="visibility" required v-model="visibility" class="form-control">
              <span class="text-danger mt-2" v-if="errors.visibility">{{ errors.visibility }}</span>
            </div>
          </div>
          <div class="mt-3" v-if="!loading">
            <input type="submit" value="Enregistrer" class="btn btn-primary">
          </div>
          <div class="mt-3 text-center" v-else>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
    </b-modal>


    <!-- DELETE MODAL -->
    <b-modal
        v-model="doesDeleteOpen"
        id="modal-center"
        title="Supprimer un contact"
        title-class="font-18"
        hide-footer
        >
        <p class="mb-2">
            Voulez-vous vraiment supprimer le contact <b>{{ contact?.name }}</b> ?
        </p>
        <div class="hstack mt-2" v-if="!loading">
          <button class="btn btn-dark ms-auto" @click="doesDeleteOpen = false">Annuler</button>
          <button class="ms-3 btn btn-danger" @click="deleteIt()">Supprimer</button>
        </div>
        <div class="text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
    </b-modal>


  </Layout>
</template>
